import { render, staticRenderFns } from "./AuthPasswordReset.vue?vue&type=template&id=64b2bcca&"
import script from "./AuthPasswordReset.vue?vue&type=script&lang=js&"
export * from "./AuthPasswordReset.vue?vue&type=script&lang=js&"
import style0 from "./AuthPasswordReset.vue?vue&type=style&index=0&id=64b2bcca&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports